import '../../styles/templates/collection.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Collection Template');
});
